
document.addEventListener('DOMContentLoaded', function() {

    // Implementación de desplazamiento automático continuo
    const sliderContainer = document.querySelector('.slider_new_landing');
    const sliderWrapper = sliderContainer.querySelector('.slider_new_landing-wrapper');
    
    // Configuración de Swiper para comportamiento base
    const swiper = new Swiper('.slider_new_landing', {
        // Configuración básica
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 12,
        grabCursor: true,
        allowTouchMove: true,
        touchRatio: 1,
        speed: 0, // Sin animación de transición para evitar pausas
        
        // Desactivar autoplay nativo de Swiper
        autoplay: false,
        
        // Configuración para mejorar el desplazamiento
        resistance: false,
        cssMode: false,
        watchSlidesProgress: true,
        preventInteractionOnTransition: false,
        
        // Si necesitamos paginación
        pagination: {
            el: '.slider_dot',
            clickable: true
        },
        
        // Flechas de navegación
        navigation: {
            nextEl: '.slider_arrow--next',
            prevEl: '.slider_arrow--prev'
        },

        breakpoints: {
            319: {
                slidesPerView: 1.5, // Muestra una diapositiva completa y parte de la siguiente
                spaceBetween: 10
            },
            768: {
                slidesPerView: 2.5, // Muestra dos diapositivas completas y parte de la tercera
                spaceBetween: 12
            },
            1201: {
                slidesPerView: 3.5, // Muestra tres diapositivas completas y parte de la cuarta
                spaceBetween: 12
            }
        }
    });
    
    // Variables para el desplazamiento automático
    let isScrolling = true;
    let scrollPosition = 0;
    let scrollSpeed = 1.5; // Velocidad de desplazamiento (píxeles por frame)
    let animationFrameId;
    let isDragging = false;
    
    // Función para el desplazamiento continuo
    function autoScroll() {
        if (isScrolling && !isDragging) {
            scrollPosition += scrollSpeed;
            
            // Cuando llegamos al final, volvemos al principio
            const maxScroll = sliderWrapper.scrollWidth - sliderContainer.offsetWidth;
            if (scrollPosition >= maxScroll) {
                scrollPosition = 0;
            }
            
            // Aplicar la posición de desplazamiento
            swiper.setTranslate(-scrollPosition);
        }
        animationFrameId = requestAnimationFrame(autoScroll);
    }
    
    // Iniciar el desplazamiento automático
    autoScroll();
    
    // Eventos para detectar cuando el usuario arrastra el slider
    sliderContainer.addEventListener('touchstart', function() {
        isDragging = true;
    }, { passive: true });
    
    sliderContainer.addEventListener('mousedown', function() {
        isDragging = true;
    });
    
    // Eventos para detectar cuando el usuario suelta el slider
    document.addEventListener('touchend', function() {
        if (isDragging) {
            isDragging = false;
            // Actualizar la posición de desplazamiento al valor actual del slider
            scrollPosition = -swiper.translate;
        }
    }, { passive: true });
    
    document.addEventListener('mouseup', function() {
        if (isDragging) {
            isDragging = false;
            // Actualizar la posición de desplazamiento al valor actual del slider
            scrollPosition = -swiper.translate;
        }
    });
    
    // Pausar al pasar el mouse por encima
    sliderContainer.addEventListener('mouseenter', function() {
        isScrolling = false;
        // Actualizar la posición de desplazamiento al valor actual del slider
        scrollPosition = -swiper.translate;
    });
    
    // Reanudar al quitar el mouse
    sliderContainer.addEventListener('mouseleave', function() {
        // Actualizar la posición de desplazamiento al valor actual del slider
        scrollPosition = -swiper.translate;
        isScrolling = true;
    });
    
    // Limpiar el animation frame al desmontar
    window.addEventListener('beforeunload', function() {
        cancelAnimationFrame(animationFrameId);
    });
});